<template>
    <div class="view" v-if="quiz">
        <md-dialog-confirm
            :md-active.sync="confirmBox.show"
            :md-title="confirmBox.title"
            :md-content="confirmBox.message"
            md-confirm-text="등록"
            md-cancel-text="취소"
            @md-confirm="onConfirm" />
            
        <md-dialog-alert
            :md-active.sync="alertBox.show"
            :md-content="alertBox.message"
            md-confirm-text="확인" />

        <h1 class="md-subheading">{{ quiz.title }}</h1>
        <div class="author-info">
            <span class="md-caption">{{ quiz.nickname }}</span> | 
            <span class="md-caption">조회: {{ quiz.view | formatNumber }}회</span> | 
            <span class="md-caption">제출: {{ quiz.score.count | formatNumber }}회</span> | 
            <span class="md-caption">평균: {{ quiz.score.average }}점</span>
        </div>

        <div class="viewport">

            <div class="input-group input-group-lg">
                <span class="input-group-addon">이름</span>
                <input type="text" class="form-control" placeholder="이름을 입력하세요." v-model="user.nickname">
            </div>

            <md-toolbar :md-elevation="1">
                <span class="md-title">{{ quiz.description }}</span>
            </md-toolbar>
            
            <md-steppers md-vertical v-if="quiz">
                <md-step 
                            :id="'q'+index" 
                            :md-label="question.title" 
                            :md-description="'정답: ' + question.userAnswer+''" 
                            v-bind:key="'q'+index" 
                            v-for="(question, index) in quiz.questions">
                    <div v-if="question.title.length > 25">{{question.title}}</div>
                    <div v-if="question.questionType == '1'">
                        <md-radio
                                v-model="question.userAnswer" 
                                :value="item.number" 
                                v-bind:key="jndex"
                                v-for="(item, jndex) in question.multipleChoices">{{item.item}}</md-radio>
                    </div>
                    <div v-if="question.questionType == null">
                        <md-field>
                            <label>주관식</label>
                            <md-input v-model="question.userAnswer"></md-input>
                            <span class="md-helper-text">정답을 입력해주세요.</span>
                        </md-field>
                    </div>
                </md-step>
            </md-steppers>
        </div>
        
        <div class="btn-group gaeup-box">
			<a type="button" class="btn btn-default" @click="gaeup()">
                <span><md-icon>thumb_up</md-icon> 깨업({{quiz.gaeup}}회)</span>
            </a>
		</div>

        <div class="btn-group btn-group-justified">
			<a type="button" class="btn btn-success" @click="share('twitter')">트위터로 점수 확인</a>
			<a type="button" class="btn btn-warning" @click="share('kakaostory')">카스로 점수 확인</a>
		</div>

        <div class="create-quiz">
            <router-link to="/add">
                <span class="md-subheading"><md-icon>create</md-icon> 퀴즈를 직접 만들어 보세요.</span>
            </router-link>
        </div>

        <!--
            광고
        -->
        <div class="ad-container">
            <Adsense
                    data-ad-client="ca-pub-2760623096296279"
                    data-ad-slot="7510070164"
                    data-ad-format="auto"
                    :data-full-width-responsive="true"
                >
            </Adsense>
        </div>
        
        <!--
            댓글
        -->
        <md-toolbar class="" md-elevation="1">
            <h3 class="md-title" style="flex: 1"><md-icon>chat</md-icon> 댓글</h3>
        </md-toolbar>

        <section class="reply_area">
            <md-list class="md-double-line" 
                                    v-if="comments"
                                >
                <div
                        v-bind:key="index"
                        v-for="(comment, index) in comments.commentList"
                    >
                    <md-list-item>
                        <md-avatar>
                            <img :src="getImage(comment.imoticon)" alt="People">
                        </md-avatar>

                        <div class="md-list-item-text">
                            <span>{{ comment.nickname }}</span>
                            <span class="comment-info">{{ getTimeString(comment.regDate) }}</span>
                            <p>{{ comment.description }}</p>
                        </div>
                    </md-list-item>
                    <md-divider class="md-inset"></md-divider>
                </div>
            </md-list>

            <div class="empty-state" 
                    v-if="comments.commentList == 0"
                >
                <md-icon>alarm_off</md-icon> 처음으로 댓글을 작성해보세요.
            </div>
            
            <div class="reply_add">
                <div class="form-group">
                    <div class="user" id="replyName" style="display: none;"><i class="fa fa-pencil"></i> 댓글을 써보세요. <i class="gae-level" id="gaeLevel" data-original-title="" title="">아직 출첵하지 않았음 [?]</i></div>
                    
                    <md-field>
                        <label>닉네임을 입력해주세요.</label>
                        <md-input v-model="user.nickname"></md-input>
                    </md-field>
                </div>
                <md-field>
                    <label>댓글을 입력해주세요.</label>
                    <md-textarea v-model="reply.description"></md-textarea>
                </md-field>
                <md-button class="md-raised md-primary" v-on:click="submitReply">댓글 등록</md-button>
            </div>
        </section>


        <!--
            광고
        -->
        <div class="ad-container">
            <Adsense
                    data-ad-client="ca-pub-2760623096296279"
                    data-ad-slot="4128280954"
                    data-ad-format="auto"
                    :data-full-width-responsive="true"
                >
            </Adsense>
        </div>

        
        <!--
            퀴즉 목록
        -->
        <md-toolbar class="" md-elevation="1">
            <h3 class="md-title" style="flex: 1"><md-icon>school</md-icon> 최근 반응 퀴즈</h3>
        </md-toolbar>

        <md-list class="md-triple-line">
            <div 
                v-bind:key="index"
                v-for="(quiz, index) in quizList"
            >
                <md-list-item @click="changeQuiz(quiz)">
                    <div class="md-list-item-text">
                        <span class="md-title">{{quiz.title}}</span>
                        <span>{{quiz.description}}</span>
                        <div class="quiz-info md-caption">
                            <md-icon>remove_red_eye</md-icon> {{quiz.view | formatNumber}}회 |
                            <md-icon>thumb_up</md-icon> {{quiz.gaeup | formatNumber}}회 |
                            <span class="green"><md-icon>school</md-icon> 평균 {{quiz.score.average}}점</span> |
                            <md-icon>assignment_ind</md-icon> {{quiz.nickname}}
                        </div>
                    </div>
                </md-list-item>
                <md-divider></md-divider>
            </div>
        </md-list>

        <!--
            광고
        -->
        <div class="ad-container">
            <Adsense
                    data-ad-client="ca-pub-2760623096296279"
                    data-ad-slot="6135976128"
                    data-ad-format="auto"
                    :data-full-width-responsive="true"
                >
            </Adsense>
        </div>
    </div>
</template>

<script>
import firebase from "firebase";
import moment from "moment";

export default {
    name: 'Home',
    components: {
        
    },
    data() {
        return {
            alertBox: {
                message: '',
                show: false
            },
            confirmBox: {
                title: '',
                message: '',
                show: false
            },
            quizList: [],
            quiz: null,
            user: null,
            comments: {
                commentList: []
            },
            reply: {}
        }
    },
    methods: {

        changeQuiz(quiz) {
            this.quiz = quiz
            window.scrollTo(0,0)
            window.location.hash = '#/' + quiz.id
            this.updateView(quiz.id)
        },

        onConfirm() {
            console.log('onConfirm')
        },

        // 점수 산출
        getScore(score) {
            if (score >= 0.97) return 'A+'
            if (score >= 0.94) return 'A'
            if (score >= 0.9)  return 'A-'
            if (score >= 0.87) return 'B+'
            if (score >= 0.84) return 'B'
            if (score >= 0.8)  return 'B-'
            if (score >= 0.77) return 'C+'
            if (score >= 0.74) return 'C'
            if (score >= 0.7)  return 'C-'
            if (score >= 0.67) return 'D+'
            if (score >= 0.64) return 'D'
            if (score >= 0.6)  return 'D-'
            return 'F'
        },

        // 점수확인
        share(platform) {
            const that = this
            let totalItem = 0
            let correctItem = 0

            if (!this.user.nickname) {
                this.alertBox.message = '이름을 입력해주세요.'
                this.alertBox.show = true
                return
            }
            localStorage.setItem('user', JSON.stringify(this.user))
            this.quiz.questions.forEach((q) => {
                const correctAnswer = q.questionType == '1' ? q.choiceAnswer : q.subjective.replace(/ /g, '')
                const userAnswer = q.userAnswer == undefined 
                                                ? '' 
                                                : typeof q.userAnswer == 'number' 
                                                        ? q.userAnswer 
                                                        : q.userAnswer.replace(/ /g, '')
                if (correctAnswer == userAnswer) {
                    correctItem++
                }
                totalItem++
            })
            const score = this.getScore(correctItem/totalItem)
            const scoreResult = correctItem/totalItem * 100
            if (this.quiz.score.count == 0) {
                this.quiz.score.average = scoreResult
                this.quiz.score.count = 1
            } else {
                this.quiz.score.average = (this.quiz.score.average * this.quiz.score.count + scoreResult * 1) / (this.quiz.score.count + 1)
                this.quiz.score.count++
            }
            this.quiz.score.average = Math.round(this.quiz.score.average * 100) / 100
            console.log(score, scoreResult)
            // 결과 update
            firebase.firestore()
                    .collection('quiz')
                    .doc(this.quiz.quizId || this.quiz.id)
                    .update({
                        excute: that.quiz.excute + 1,
                        score: that.quiz.score,
                        updateDate: new Date()
                    })
                    .then(() => {
                        let post = ''
                        post += this.getSpecial() + ' ' + that.quiz.title + '\n'
                        post += that.user.nickname + '님의 점수는 ' + Math.round(scoreResult * 100) / 100 + '점 입니다.\n';
                        post += '──\n'
                        post += that.quiz.questions[0].title + '\n'
                        
                        const data = {
                            post: post,
                            desc: that.quiz.description,
                            img: '',
                            url: that.quiz.shortUrl,
                            media: platform
                        }
                        this.shareData(data)
                    })
        },

        shareData(_obj) {
            var  obj = _obj || {}
                ,media = obj.media || 'story'
                //,id = obj.id || 'gaeyou'
                //,ver = obj.ver || '1.0'
                //,app = obj.app || '★깨알유머★를 검색하세요!!'
                //,title = obj.title || ''
                ,url = obj.url || ''
            
            //try{
                //Kakao.init('77a3ab1c153e43f5d6b00426dfd02985');
            //} catch(e){}
            
            /*
            if (media == 'talk') {
                var  msg = obj.msg || title || ''

                Kakao.Link.sendTalkLink({
                    image: {
                        src: obj.img,
                        width: '380',
                        height: '380'
                    },
                    label: obj.post + '\n\n' + obj.url
                });
                
                test  = '♥♥ [카톡친구 초대] ♥♥\n'
                test += 'appId: ' + id + '\n'
                test += 'appVersion: ' + ver + '\n'
                test += 'appName: ' + app + '\n'
                test += 'msg: \n'
                test += '-----------\n'
                test += msg + '\n'
                test += '-----------\n'
                test += 'url: ' + url + '\n'
                test += '--------------------------------------------\n'
                console.log(test)
                return false;
            }
            */

            if (media == 'kakaostory') {
                window.Kakao.Story.open({
                    url: obj.url,
                    text: obj.post
                });
                
                test  = '♥♥ [카스로 공유] ♥♥\n'
                test += 'post: \n'
                test += '-----------\n'
                test += post + '\n'
                test += '-----------\n'
                console.log(test);
                
                return false;
            }

            if (media == 'twitter') {
                var  str = ''
                    ,post = obj.twit || obj.post || ''
                    ,urlLength = url.length + 5
                    ,postLength = post.length + urlLength + 1
                    ,textLimit = 140
                    ,twit = ''
                    ,test = ''
                
                if (postLength >= textLimit) {
                    twit = post.substr(0, (textLimit-urlLength)) + '...\n' + url;
                } else {
                    twit = post + '\n' + url;
                }
                twit = twit.replace(/\n\n/g, '\n')

                str += 'https://twitter.com/intent/tweet?text=';
                str += encodeURIComponent(twit);
                top.location.href = str;
                //return false;

                test  = '♥♥ [트위터로 공유] ♥♥\n'
                test += 'twit: \n'
                test += '-----------\n'
                test += twit + '\n'
                test += '-----------\n'
                console.log(test)
                return false;
            }
            /*
            // facebook sharer
            if (media == 'facebookSharer') {//
                var  str = ''
                    ,post = obj.post || ''
                    ,img = obj.img || ''
                
                str += 'http://www.facebook.com/sharer.php';
                str += '?s=100';
                str += '&p[title]=' + encodeURIComponent( post.replace(/\[.+\]/g, '') );
                str += '&p[summary]=' + encodeURIComponent( title );
                str += '&p[url]=' + encodeURIComponent(url);
                str += '&p[images][0]=' + encodeURIComponent(img);
                top.location.href = str;
                return false;
            }

            // facebook open API
            if (media == 'facebook') {//API
                M('body').prepend('script', {
                    'src':'https://connect.facebook.net/en_US/all.js',
                    'type': 'text/javascript',
                    'id': 'facebookScript'
                })

                M('#facebookScript').on('load', function(evt, mp){
                    var  obj = _obj || {}
                        ,mode = obj.mode || 'real'
                        ,feed = obj.feed || 'feed'
                        ,method = obj.method || 'post'
                        ,img = obj.img || ''
                        ,photo = obj.photo || obj.img || ''
                        ,post = obj.post || ''
                        ,scope = obj.scope || 'publish_actions, user_photos'
                        ,success = obj.success || null
                        ,error = obj.error || null
                        ,faceappid
                        ,message = {}

                    post = post + '\n\n' + url;

                    if (mode == 'real') {
                        faceappid = '193169104219931';
                    } else {
                        faceappid = '199304076906232';
                    }

                    if (feed == 'feed') {
                        message = {
                            'message': post,
                            'picture': photo
                        }
                    } else if (feed == 'photo') {
                        message = {
                            'message': post,
                            'url': photo
                        }
                    }

                    FB.init({
                        'appId'     : faceappid, // App ID
                        'channelUrl': '//WWW.YOUR_DOMAIN.COM/channel.html', // Channel File
                        'status'    : true, // check login status
                        'cookie'    : true, // enable cookies to allow the server to access the session
                        'xfbml'     : true  // parse XFBML
                    })

                    FB.login(function(response) {
                        if (response.authResponse) {
                            FB.api(/me/ + feed, method, message, function (response) {
                                console.log(response);
                                if (!response || response.error) {
                                    //if (error) {
                                    alert('죄송합니다.\n오류가 발생했습니다.');
                                        //error();
                                    //}
                                } else {
                                    //if (success) {
                                    alert('페이스북에 등록 되었습니다.');
                                        //success();
                                    //}
                                }
                            });
                        }
                    }, {'scope': scope});

                    //return false;
                    test  = '♥♥ [페이스북으로 공유] ♥♥\n'
                    test += 'feed: ' + feed + '\n'
                    test += 'method: ' + method + '\n'
                    test += 'photo: ' + photo + '\n'
                    test += 'message: \n'
                    test += '-----------\n'
                    test += post + '\n'
                    test += '-----------\n'
                    console.log(test)

                })
                return false;
            }

            if (media == 'band') {
                var  src = ''
                    ,post = obj.post || ''
                    ,urlLength = url.length + 3
                    ,postLength = post.length + urlLength + 1
                    ,textLimit = 300

                bandPost += '[' + app + ']\n'
                bandPost += title + ': ' + post

                if (postLength >= textLimit) {
                    b = bandPost.substr(0, (textLimit-urlLength)) + '...' + url;
                } else {
                    b = bandPost + ' ' + url;
                }

                src += 'bandapp://create/post?text=';
                src += encodeURIComponent(bandPost);
                src += '#Intent;package=com.nhn.android.band;end;';
                top.location = str;
                return false;
            }
            */
        },

        getQuiz() {
            const that = this
            const quizId = this.$route.params.id
            
            if (quizId) {
                firebase.firestore()
                        .collection('quiz')
                        .doc(quizId)
                        .get()
                        .then(doc => {
                            if (!doc.exists) {
                                return window.location.hash = '#/'
                            }
                            that.quiz = doc.data()
                            that.quiz.quizId = doc.id
                            if (!that.quiz.description) {
                                that.quiz.description = that.quiz.title
                            }
                            that.updateView(quizId)
                        })
                        .catch(() => {
                            localStorage.removeItem('user')
                            location.reload()
                        })
            }
            
            // 퀴즈 목록 가져오기
            firebase.firestore()
                    .collection('quiz')
                    .orderBy('regDate', 'desc')
                    .limit(100)
                    .get()
                    .then(querySnapshot => {
                        querySnapshot.forEach(function(doc) {
                            let q = doc.data()
                            q.id = doc.id
                            
                            // 퀴즈 표시
                            if (!that.quiz) {
                                that.quiz = q
                                that.quiz.quizId = doc.id
                                if (!that.quiz.description) {
                                    that.quiz.description = that.quiz.title
                                }
                                that.updateView(doc.id)
                            }
                            that.quizList.push(q)
                        });
                    })
                    .catch(() => {
                        localStorage.removeItem('user')
                        location.reload()
                    })
        },

        // view update
        updateView(quizId) {
            this.getReply(quizId)
            const that = this
            that.quiz.view++
            firebase.firestore()
                    .collection('quiz')
                    .doc(quizId)
                    .update({
                        view: that.quiz.view,
                        updateDate: new Date()
                    })
        },

        // 댓글 등록
        submitReply() {
            if (!this.user.nickname) {
                this.alertBox.message = '닉네임을 입력해 주세요.'
                this.alertBox.show = true
                return
            }
            if (!this.reply.description) {
                this.alertBox.message = '댓글을 입력해 주세요.'
                this.alertBox.show = true
                return
            }
            const that = this
            this.reply.userId = this.user.id
            this.reply.nickname = this.user.nickname
            this.reply.quizId = this.quiz.quizId
            this.reply.imoticon = 'smile' + this.getRandom(1, 5) + '.png'
            this.reply.regDate = new Date()
            this.comments.commentList.push(this.reply)
            localStorage.setItem('user', JSON.stringify(this.user))

            firebase.firestore()
                    .collection('reply')
                    .doc(this.quiz.quizId)
                    .set(this.comments)
                    .then(() => {
                        that.reply.description = ''
                    })

        },

        // 댓글 가져오기
        getReply(quizId) {
            firebase.firestore()
                .collection('reply')
                .doc(quizId)
                .onSnapshot((doc) => {
                    if (!doc.data()) {
                        this.comments.commentList = []
                    } else {
                        this.comments = doc.data()
                    }
                })
        },

        // 깨업
        gaeup() {
            const that = this

            if (this.getCanGaeup()) {
                that.quiz.gaeup++
                firebase.firestore()
                    .collection('quiz')
                    .doc(that.quiz.quizId)
                    .update({
                        gaeup: that.quiz.gaeup,
                        updateDate: new Date()
                    })
                    .then(() => {
                        that.user.gaeups.push(that.quiz.quizId)
                        localStorage.setItem('user', JSON.stringify(that.user))
                    })
            }
            
        },

        getCanGaeup() {
            const that = this
            let canGaeup = true
            this.user.gaeups.forEach(quizId => {
                if (that.quiz.quizId == quizId) {
                    canGaeup = false
                }
            })
            return canGaeup
        },

        getSpecial() {
            var data = ['🐍','🐎','🐚','🐛','🐜','🐝','🐯','🐮','🐭','🐬','🐫','🐟','🐞','🐺','🐻','🐼','🐽','🐾',
                        '🐑','🐒','🐢','🐡','🐠','🐙','🐘','🐗','🐔','🐣','🐤','🐥','🐦','🐧','🐨','🐩'],
            sc = this.process(data)
            return data[sc]
        },

        process(_min, _max){
            var data, min, max

            if ( this.getDataType(_min) === 'object' || this.getDataType(_min) === 'array' ) {
                data = _min;
                return Math.floor(Math.random() * data.length);
            } else {
                min = _min;
                max = _max;
                return Math.floor(Math.random() * (max-min) + min)
            }
        },

        getDataType(_value) {
            if (typeof _value === 'string')         return 'string'
            if (typeof _value === 'number')         return 'number'
            if (_value.constructor === Object)      return 'object'
            if (_value.constructor === Array)       return 'array'
            if (_value.constructor === Function)    return 'function'
            if (_value.constructor === Boolean)     return 'boolean'
                                                    return undefined
        },

        updateUser(user) {
            const that = this
            const saveUser = {
                id: user.uid,
                gaeups: [],
                userAgent: navigator.userAgent,
                regDate: new Date()
            }
            firebase
                .firestore()
                .collection('user')
                .doc(user.uid)
                .set(saveUser)
                .then(() => {
                    localStorage.setItem('user', JSON.stringify(saveUser))
                    that.user = saveUser
                    that.getQuiz()
                })
        },
        getTimeString(timestamp) {
            if (timestamp.toDate) {
                const date = timestamp.toDate()
                return moment(date).locale('ko').fromNow()
            }
        },
        getRandom(start, end) {
            return Math.floor((Math.random() * (end-start+1)) + start);
        },
        getImage(img) {
            return require('@/assets/'+img)
        }
    },
    created() {
        const that = this
        this.user = JSON.parse(localStorage.getItem('user'))

        if (this.user) {
            return that.getQuiz()
        }
        // 로그인 체크
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                that.updateUser.call(that, user)
            } else {
                firebase.auth().signInAnonymously()
            }
        });
        
    }
}
</script>

<style scoped>
a, .md-list-item-text {
    color:#666 !important
}
.warper {
    background-color: #fff;
}
.view h1 {
    font-size: 18px;
    padding: 0 0 3px 15px;
    border-bottom: 1px solid #acaba8;
}
.author-info {
    text-align: right;
    padding-right: 10px;
}
.create-quiz {
    text-align: center;
    padding: 10px;
}
.gaeup-box {
    text-align: center;
    width:100%;
    padding: 20px
}
.gaeup-box > a {
    float:none !important;
    padding: 8px 10px;
}
.viewport {
    width: 100%;
    max-width: 100%;
    display: inline-block;
    vertical-align: top;
    overflow: auto;
    border: 1px solid rgba(#000, .12);
}
.md-steppers {
    width:100%
}
.md-radio {
    display: flex;
}
.btn-group, .btn-group-vertical {
    position: relative;
    display: inline-block;
    vertical-align: middle;
}
.btn-default {
    color: #333 !important;
    background-color: #fff;
    border-color: #ccc !important;
}
.btn-group>.btn, .btn-group-vertical>.btn {
    position: relative;
    float: left;
}
.btn-group>.btn:first-child {
    margin-left: 0;
}
.btn-group-justified {
    display: table;
    width: 90%;
    margin:0 auto;
    border-collapse: separate;
    table-layout: fixed;
}
.btn-group, .btn-group-vertical {
    position: relative;
    vertical-align: middle;
}
.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
.btn-group>.btn:last-child:not(:first-child), .btn-group>.dropdown-toggle:not(:first-child) {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
}
.btn {
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: normal;
    line-height: 1.428571429;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
    user-select: none;
}
.btn-success {
    color: #fff !important;
    background-color: #5cb85c;
    border-color: #4cae4c;
}
.btn-warning {
    color: #fff !important;
    background-color: #f0ad4e;
    border-color: #eea236;
}
.btn-group>.btn, .btn-group-vertical>.btn {
    position: relative;
    float: left;
}
.btn-group-justified>.btn, .btn-group-justified>.btn-group {
    display: table-cell;
    float: none;
    width: 1%;
}
.warper {
    margin:15px;
    padding: 0 15px
}
.warper > .md-field {
    margin-bottom: 45px
}
.quiz-bottons {
    text-align: center;
}
.md-list-item-text * {
    width: inherit;
    margin-top:4px
}
.green {
    color: #5cb85c !important;
}
.input-group {
    width: 90%;
    margin: 16px auto;
    position: relative;
    display: table;
    border-collapse: separate;
}
.input-group-addon:first-child {
    border-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
.input-group-lg>.input-group-addon {
    height: 46px;
    padding: 10px 16px;
    font-size: 18px;
    line-height: 1.33;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
}
.input-group-addon {
    font-weight: normal;
    color: #555;
    text-align: center;
    background-color: #eee;
    border: 1px solid #ccc;
    width: 1%;
    white-space: nowrap;
    vertical-align: middle;
    display: table-cell;
}
.input-group .form-control:last-child {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
}
.input-group .form-control {
    display: table-cell;
}
.input-group-lg>.form-control {
    height: 46px;
    padding: 10px 16px;
    font-size: 18px;
    line-height: 1.33;
    border-radius: 6px;
}
.input-group .form-control {
    width: 100%;
    margin-bottom: 0;
}
.form-control {
    color: #555;
    vertical-align: middle;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
}

/* 댓글 */
.reply_area {border-bottom: 1px solid #acaba8; margin-bottom:15px}
.reply_area h2 {overflow: hidden;height: 38px;border-bottom: 1px solid #acaba8;color: #000;line-height: 39px;font-size: 16px;font-weight: bold; padding-left:15px; background:#DFDFDF}
.reply_area .profile {position: absolute;}
.reply_area .profile .photo {float: left;}
.reply_area .profile .photo img {width: 36px;height: 36px;border-radius: 5px;}
.reply_area .profile .user {float: left;margin-left: 10px;}
.reply_area .profile .user .date {color:#CACACA}
.reply_area .desc {padding: 20px 0 0 46px;}
/* .reply_area li {padding: 10px 20px 10px 16px;border-top: 1px solid #dddddf;list-style:none} */
.reply_area .no_reply {text-align:center; padding:20px; font-weight:bold; font-size:17px; color:#6D6D6D}
.reply_area .reply_add {position:relative; background:#f0f0f4; padding:4px 10px 5px 10px; border-top: 1px solid #acaba8;}
.reply_area .reply_add .user {position:absolute; top:11px; left:13px}
.reply_area .form-group {margin-bottom:5px}
.reply_area .form-group.btn-reg {text-align:right;}
.reply_area .empty-state {padding: 50px; text-align:center}
.reply_area .comment-info {
    position: absolute; top:6px; right: 15px
}
.md-list-item-text p {
  white-space: normal;
  padding-bottom: 1rem;
}
</style>